/**
 * VIP Loyalty Program JavaScript
 * Handles: popup open/close, variant price updates, logged-in subscribe flow
 */

(function () {
  'use strict';

  /* ------------------------------------------
     1. Popup Open / Close
     ------------------------------------------ */
  function initPopup() {
    var popup = document.querySelector('.vip-popup-overlay');
    if (!popup) return;

    // Open triggers — any element with data-vip-signup-trigger.
    // Registered on WINDOW in capture phase — the first node in event
    // propagation — so it runs before Boost SD's handleCoreClick
    // (filter.module.js), which programmatically navigates to the PDP
    // and ignores preventDefault. For triggers inside a product card or
    // link, stop the event before it can reach any card handler.
    window.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[data-vip-signup-trigger]');
      if (!trigger) return;
      e.preventDefault();
      if (trigger.closest('a, .boost-sd__product-item, .product-block')) {
        e.stopPropagation();
      }
      openVipPopup();
    }, true);

    // Close button
    var closeBtn = popup.querySelector('.vip-popup__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        closePopup(popup);
      });
    }

    // Close on overlay click
    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        closePopup(popup);
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-active')) {
        closePopup(popup);
      }
    });
  }

  function openVipPopup() {
    var popup = document.querySelector('.vip-popup-overlay');
    if (!popup) return;
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closePopup(popup) {
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /* ------------------------------------------
     2. PDP Variant Change — VIP Price Updates
     Supports: theme variant-picker, Swatch King,
     and any app that changes ?variant= in the URL
     or updates select[name="id"].
     ------------------------------------------ */
  function initVariantPriceUpdates() {
    var dataEl = document.getElementById('vip-price-data');
    if (!dataEl) return;

    var vipData;
    try {
      vipData = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var isVip = window.__IVY_ROSE_VIP === true;
    var isLoggedIn = window.__IVY_ROSE_LOGGED_IN === true;
    var priceDisplay = document.querySelector('[data-vip-price-display]');
    if (!priceDisplay) return;

    // Swatch King uses select[name="id"] as source of truth (URL may be stale)
    var lastVariantId = getVariantIdFromSelect() || getVariantIdFromUrl();

    // Ensure VIP price is shown on initial load for the active variant
    if (lastVariantId) {
      applyVipForVariant(lastVariantId);
    }

    /**
     * Central update function — given a variant ID, update the VIP price
     * display to show the correct state. If the variant has no VIP price
     * (custom_price is null or variant not in map), hides VIP display.
     */
    function applyVipForVariant(variantId) {
      if (!variantId) return;
      lastVariantId = String(variantId);

      var variantVip = vipData[lastVariantId];
      if (variantVip) {
        updatePriceDisplay(priceDisplay, { price: variantVip.price }, variantVip, isVip);
      } else {
        // Variant not in VIP data map — show empty state (no price data available)
        updatePriceDisplay(priceDisplay, { price: 0 }, { custom_price: null, price: 0 }, isVip);
      }
    }

    // --- Strategy 1: Theme's native variant change event ---
    document.addEventListener('on:variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      applyVipForVariant(String(variant.id));
    });

    // --- Strategy 2: Hidden select change (some apps dispatch this) ---
    var variantSelect = document.querySelector('select[name="id"]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var selectedId = variantSelect.value;
        if (!selectedId || selectedId === lastVariantId) return;
        applyVipForVariant(selectedId);
      });
    }

    // --- Strategy 3: Poll select[name="id"] for variant changes (Swatch King) ---
    // Swatch King sets select.value programmatically without dispatching a
    // change event, and does NOT update the URL. Poll the select directly.
    var urlPollInterval = setInterval(function () {
      var currentId = getVariantIdFromSelect() || getVariantIdFromUrl();
      if (currentId && currentId !== lastVariantId) {
        applyVipForVariant(currentId);
      }
    }, 300);

    // --- Strategy 4: MutationObserver on price container ---
    // If Swatch King overwrites the price HTML, re-inject VIP price.
    var priceContainer = priceDisplay.closest('.product-info__price');
    if (priceContainer) {
      var reinjecting = false;
      var priceObserver = new MutationObserver(function () {
        if (reinjecting) return;
        // Check if our VIP display was removed by an external app
        if (!priceContainer.querySelector('[data-vip-price-display]')) {
          reinjecting = true;
          // Re-inject the VIP price display wrapper
          priceContainer.innerHTML = '';
          priceDisplay = document.createElement('div');
          priceDisplay.className = 'vip-price-display vip-price-display--pdp';
          priceDisplay.setAttribute('data-vip-price-display', '');
          priceContainer.appendChild(priceDisplay);

          // Always read fresh variant ID from select (not lastVariantId)
          // because Swatch King updates select before re-rendering
          var freshId = getVariantIdFromSelect() || getVariantIdFromUrl() || lastVariantId;
          applyVipForVariant(freshId);
          reinjecting = false;
        }
      });

      priceObserver.observe(priceContainer, { childList: true, subtree: true });
    }

    // Clean up polling if page unloads
    window.addEventListener('pagehide', function () {
      clearInterval(urlPollInterval);
    });
  }

  /** Extract variant ID from the URL ?variant= parameter */
  function getVariantIdFromUrl() {
    var match = window.location.search.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }

  /** Extract variant ID from the hidden select[name="id"] */
  function getVariantIdFromSelect() {
    var sel = document.querySelector('select[name="id"]');
    return sel && sel.value ? sel.value : null;
  }

  /**
   * Renders the VIP price display for a given variant.
   * Only updates the price portion inside [data-vip-price-display].
   * The CTA is rendered server-side by vip-price-display.liquid (render_part: 'cta')
   * and toggled here via show/hide on .vip-price-cta-wrapper.
   */
  function updatePriceDisplay(container, variant, vipInfo, isVip) {
    var hasVipPrice = vipInfo.custom_price !== null;
    var hasSalePrice = vipInfo.sale_price != null;
    var originalPrice = formatMoney(variant.price);
    var html = '';

    // Toggle the server-rendered CTA wrapper visibility based on variant VIP state
    var ctaWrapper = document.querySelector('.vip-price-cta-wrapper');
    if (ctaWrapper) {
      ctaWrapper.style.display = hasVipPrice && !isVip ? '' : 'none';
    }

    if (hasSalePrice) {
      // Public sale — same for every shopper
      var saleLabel = (window.__IVY_ROSE_VIP_SETTINGS || {}).saleLabel || 'Holiday Sale';
      html =
        '<div class="vip-price__prices">' +
          '<span class="vip-price__original"><s>' + formatMoney(vipInfo.sale_original || variant.price) + '</s></span>' +
          '<span class="vip-price__discounted">' + formatMoney(Math.round(parseFloat(vipInfo.sale_price) * 100)) + '</span>' +
          '<span class="public-sale__label">' + escapeHtml(saleLabel) + '</span>' +
        '</div>';
    } else if (hasVipPrice) {
      var vipPriceCents = Math.round(parseFloat(vipInfo.custom_price) * 100);
      var vipPrice = formatMoney(vipPriceCents);

      var diamondIconUrl = (window.__IVY_ROSE_VIP_SETTINGS || {}).diamondIconUrl || '';

      if (isVip) {
        // STATE 1: VIP — show discounted price
        var iconHtml = diamondIconUrl
          ? '<img src="' + diamondIconUrl + '" alt="" class="vip-price__diamond-icon" width="20" height="16"> '
          : '';
        html =
          '<div class="vip-price__prices">' +
            '<span class="vip-price__original"><s>' + originalPrice + '</s></span>' +
            '<span class="vip-price__discounted">' + vipPrice + '</span>' +
            '<span class="vip-price__flair">' + iconHtml + 'VIP price</span>' +
          '</div>' +
          '<div class="vip-price__label--exclusive">Email subscriber exclusive</div>';
      } else {
        // STATE 2/3: Non-VIP — price only (CTA handled by Liquid-rendered .vip-price-cta-wrapper)
        html =
          '<div class="price__default">' +
            '<span class="price__current">' + originalPrice + '</span>' +
          '</div>';
      }
    } else {
      // STATE 4: No VIP price on this variant — show original price only
      html =
        '<div class="price__default">' +
          '<span class="price__current">' + originalPrice + '</span>' +
        '</div>';
    }

    container.innerHTML = html;
  }

  function formatMoney(cents) {
    if (typeof theme !== 'undefined' && theme.shop && theme.shop.money_format) {
      return formatMoneyWithFormat(cents, theme.shop.money_format);
    }
    // Fallback: simple USD formatting
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function formatMoneyWithFormat(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) {
      return typeof opt === 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var pennies = parts.length > 1 ? decimal + parts[1] : '';

      return dollars + pennies;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* ------------------------------------------
     3. Boost SD PLP — VIP Price Integration
     Targets Boost Search & Discovery product cards.
     Reads VIP price map from #vip-collection-data,
     injects badge + price elements into Boost SD DOM.
     ------------------------------------------ */
  function initBoostVipPrices() {
    // Debug logging — set window.__IVY_ROSE_VIP_DEBUG = false to silence
    var DEBUG = window.__IVY_ROSE_VIP_DEBUG !== false;
    function vlog() {
      if (!DEBUG) return;
      var args = Array.prototype.slice.call(arguments);
      args.unshift('[VIP]');
      console.log.apply(console, args);
    }

    var mapEl = document.getElementById('vip-collection-data');
    if (!mapEl) {
      vlog('No #vip-collection-data element found — Boost VIP integration aborted');
      return;
    }

    var vipMap;
    try {
      vipMap = JSON.parse(mapEl.textContent);
    } catch (e) {
      vlog('Failed to parse #vip-collection-data JSON', e);
      return;
    }

    var isVip = window.__IVY_ROSE_VIP === true;
    var settings = window.__IVY_ROSE_VIP_SETTINGS || {};
    vlog('Initialized. isVip=' + isVip + ', products in map=' + Object.keys(vipMap).length, vipMap);
    var badgeText = settings.badgeText || 'Loyalty Discount';
    var exclusiveLabel = settings.exclusiveLabel || 'Email subscriber exclusive';
    var discountLabel = settings.discountLabel || 'VIP discount available';
    var saleLabel = settings.saleLabel || 'Holiday Sale';
    var debounceTimer = null;
    var observer;
    // Product handles already requested via the per-product data template
    var fetchedHandles = {};

    /**
     * Remove all VIP-injected elements from a card and restore
     * Boost's default price visibility.
     */
    function clearVipFromCard(card) {
      var badge = card.querySelector('.vip-badge--boost');
      if (badge) badge.remove();

      var vipPriceDisplay = card.querySelector('.vip-price-display--plp');
      if (vipPriceDisplay) vipPriceDisplay.remove();

      var vipLabel = card.querySelector('.vip-price__label--vip-discount');
      if (vipLabel) vipLabel.remove();

      // Restore Boost's default price
      var boostPrice = card.querySelector('.boost-sd__product-price');
      if (boostPrice) boostPrice.style.removeProperty('display');

      card.removeAttribute('data-vip-product-id');
    }

    function processCard(card) {
      var productId = card.getAttribute('data-product-id');
      if (!productId) return;

      var renderedForId = card.getAttribute('data-vip-product-id');

      // Swatch King changed the product — tear down stale VIP elements
      if (renderedForId && renderedForId !== productId) {
        clearVipFromCard(card);
      }

      var vipInfo = vipMap[productId];

      // No VIP data for this product — clean up any leftover elements
      if (!vipInfo) {
        vlog('Card product ' + productId + ' has NO entry in VIP map — skipping');
        if (renderedForId) clearVipFromCard(card);
        return;
      }

      // Sold-out cards keep only Boost's Sold label
      if (card.querySelector('.boost-sd__product-label--soldout')) {
        if (renderedForId) clearVipFromCard(card);
        return;
      }

      // Already rendered VIP for this exact product — nothing to do
      if (renderedForId === productId) return;

      vlog('Rendering VIP for product ' + productId, vipInfo);

      // Mark the card so we know which product the VIP elements belong to
      card.setAttribute('data-vip-product-id', productId);

      var isSale = vipInfo.sale != null;

      // --- VIP / public sale Badge ---
      var imageWrapper = card.querySelector('.boost-sd__product-image-wrapper');
      if (imageWrapper && imageWrapper.parentNode) {
        var badge = document.createElement('span');
        badge.className = 'vip-badge vip-badge--boost' + (isSale ? ' public-sale-badge' : '');
        badge.textContent = isSale ? saleLabel : badgeText;
        imageWrapper.parentNode.appendChild(badge);
      }

      // --- VIP Price ---
      var infoEl = card.querySelector('.boost-sd__product-info');
      if (!infoEl) {
        vlog('Card product ' + productId + ' — no .boost-sd__product-info element found, cannot inject price');
        return;
      }

      if (isSale || isVip) {
        var boostPrice = card.querySelector('.boost-sd__product-price');
        if (boostPrice) boostPrice.style.setProperty('display', 'none', 'important');

        var prefix = vipInfo.varies ? 'From ' : '';
        var vipPriceDiv = document.createElement('div');
        vipPriceDiv.className = 'vip-price-display vip-price-display--plp';
        vipPriceDiv.innerHTML =
          '<div class="vip-price__prices">' +
            '<span class="vip-price__discounted">' + prefix + formatMoney(isSale ? vipInfo.sale : vipInfo.vip) + '</span>' +
            '<span class="vip-price__original"><s>' + formatMoney(vipInfo.price) + '</s></span>' +
            (isSale ? '' : '<span class="vip-price__label--exclusive">' + escapeHtml(exclusiveLabel) + '</span>') +
          '</div>';

        infoEl.appendChild(vipPriceDiv);
      } else {
        var priceWrapper = card.querySelector('.boost-sd__product-price-wrapper');
        if (priceWrapper) {
          var label = document.createElement('span');
          label.className = 'vip-price__label--vip-discount';
          label.setAttribute('data-vip-signup-trigger', '');
          label.textContent = discountLabel;
          priceWrapper.appendChild(label);
        }
      }
    }

    /**
     * For each visible card missing from the VIP map, fetch that product's
     * VIP data individually via the product.vip-data template. Per-product
     * requests stay under Shopify's per-page metafield access limit (which
     * silently blanks metafields when a collection loop reads too many).
     */
    function fetchMissingProducts(cards) {
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var id = card.getAttribute('data-product-id');
        if (!id || vipMap[id]) continue;

        var handle = getCardHandle(card);
        if (!handle || fetchedHandles[handle]) continue;

        fetchedHandles[handle] = true;
        fetchProductVip(handle);
      }
    }

    /** Extract the product handle from the card's product link. */
    function getCardHandle(card) {
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return null;
      var match = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return match ? match[1] : null;
    }

    function fetchProductVip(handle) {
      fetch('/products/' + handle + '?view=vip-data')
        .then(function (res) { return res.text(); })
        .then(function (text) {
          var data;
          try {
            data = JSON.parse(text.trim());
          } catch (e) {
            return;
          }
          if (data && data.id) {
            vipMap[data.id] = { vip: data.vip, sale: data.sale, price: data.price, varies: data.varies };
            debouncedProcess();
          }
        })
        .catch(function () {
          // Network error — allow a later re-render to retry
          fetchedHandles[handle] = false;
        });
    }

    // Stable node to observe. Boost SD replaces the whole
    // .boost-sd__product-list node when filters/sorting/pagination change,
    // so observing that node directly leaves us attached to a detached,
    // dead node after the first filter. Observe document.body instead — it
    // survives every Boost re-render and still catches the new cards.
    var observeTarget = document.body;

    function processAllCards() {
      // Disconnect observer while we modify DOM to avoid re-triggering
      if (observer) observer.disconnect();

      var cards = document.querySelectorAll('.boost-sd__product-item[data-product-id]');

      vlog('processAllCards — found ' + cards.length + ' Boost card(s) with data-product-id');

      // Process known cards and collect unknown ones for fetching
      for (var i = 0; i < cards.length; i++) {
        processCard(cards[i]);
      }

      // Fetch VIP data for any cards still missing from the map, per product
      fetchMissingProducts(cards);

      // Reconnect observer to the stable target
      if (observer) observer.observe(observeTarget, { childList: true, subtree: true });
    }

    function debouncedProcess() {
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processAllCards, 50);
    }

    // Process cards already rendered
    processAllCards();

    // Watch for Boost SD (filter/sort/paginate) and Swatch King re-renders.
    // Observing body ensures we keep firing even after Boost swaps out the
    // entire product-list container.
    observer = new MutationObserver(debouncedProcess);
    observer.observe(observeTarget, { childList: true, subtree: true });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ------------------------------------------
     4. Cart Page — Ensure VIP Discount Applied
     The VIP discount is a checkout discount function keyed off the customer's
     VIP tag. The cart reflects it only once its discount allocations are
     recomputed, which may not have happened yet (e.g. cart built before the
     customer became VIP). On the cart page, if a VIP shopper has items but no
     discount shows, bump a cart attribute to force a recalc, then reload once.
     A per-cart signature guard prevents reload loops when the discount
     legitimately does not apply (e.g. minimum-spend not met).
     ------------------------------------------ */
  function initCartVipDiscount() {
    if (window.__IVY_ROSE_VIP !== true) return;
    if (!/\/cart\/?$/.test(window.location.pathname)) return;

    var SIG_KEY = 'vip_cart_refresh_sig';

    function cartHasDiscount(cart) {
      if (!cart) return false;
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) return true;
      if (cart.total_discount && cart.total_discount > 0) return true;
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        var allocs = items[i].discount_allocations || items[i].line_level_discount_allocations;
        if (allocs && allocs.length) return true;
      }
      return false;
    }

    function signature(cart) {
      return [cart.token, cart.item_count, cart.items_subtotal_price].join('_');
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) return;

        if (cartHasDiscount(cart)) {
          sessionStorage.removeItem(SIG_KEY);
          return;
        }

        var sig = signature(cart);
        if (sessionStorage.getItem(SIG_KEY) === sig) return; // already attempted this cart

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { _vip_refresh: Date.now().toString() } })
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) {
            if (cartHasDiscount(updated)) {
              window.location.reload();
            } else {
              sessionStorage.setItem(SIG_KEY, sig); // remember; avoid reload loop
            }
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  /* ------------------------------------------
     5. Cart — Public Sale Line Property
     Keeps the private _public_sale property in step with the product's
     public-sale tag: adds it to lines that were added without it (quick add,
     wishlist, older carts) and drops it once the tag is removed. Runs on the
     cart page and whenever the cart drawer opens.
     ------------------------------------------ */
  var publicSaleSyncing = false;
  var PUBLIC_SALE_TRIED_KEY = 'public_sale_sync_tried';

  function syncPublicSaleLines() {
    if (publicSaleSyncing) return;
    publicSaleSyncing = true;

    // Line keys already attempted this session, so a rejected change can't cause a reload loop
    var tried = (sessionStorage.getItem(PUBLIC_SALE_TRIED_KEY) || '').split(',');

    fetch('/cart?view=public-sale-sync', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var lines = JSON.parse(text.trim()).filter(function (line) {
          return tried.indexOf(line.key) === -1;
        });
        if (!lines.length) return false;

        // Sequential: each change re-keys its line, and concurrent cart writes can drop updates
        return lines.reduce(function (chain, line) {
          return chain.then(function (changed) {
            tried.push(line.key);
            sessionStorage.setItem(PUBLIC_SALE_TRIED_KEY, tried.join(','));

            var properties = Object.assign({}, line.properties);
            if (line.publicSale) {
              properties._public_sale = 'yes';
            } else {
              delete properties._public_sale;
            }

            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: properties })
            }).then(function (r) { return changed || r.ok; });
          });
        }, Promise.resolve(false));
      })
      .then(function (changed) {
        if (!changed) return;
        if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
        } else {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        }
      })
      .catch(function () {})
      .then(function () {
        publicSaleSyncing = false;
      });
  }

  function initPublicSaleCartSync() {
    if (/\/cart\/?$/.test(window.location.pathname)) syncPublicSaleLines();
    document.addEventListener('on:cart-drawer:before-open', syncPublicSaleLines);
  }

  /* ------------------------------------------
     6. Swatch King — Public Sale Prices
     Swatch King dropdowns show regular prices: "Choose Style" lists sibling
     products (one request for all products tagged public-sale), and option
     dropdowns like Size list the main product's variants (#vip-price-data).
     Sale entries get the regular price struck through and the sale price.
     ------------------------------------------ */
  function initSwatchSalePrices() {
    var salesRequest = null;
    var debounceTimer = null;
    var variantData = null;
    var dataEl = document.getElementById('vip-price-data');
    if (dataEl) {
      try {
        variantData = JSON.parse(dataEl.textContent);
      } catch (e) {
        variantData = null;
      }
    }
    var optionScope = dataEl ? dataEl.closest('.product-info') || document : null;

    function loadSales() {
      if (!salesRequest) {
        salesRequest = fetch('/collections/all/public-sale?view=public-sale-data')
          .then(function (r) { return r.text(); })
          .then(function (text) { return JSON.parse(text.trim()); })
          .catch(function () { return {}; });
      }
      return salesRequest;
    }

    function handleFromUrl(url) {
      var match = (url || '').match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    }

    function applyPrice(priceEl, info) {
      if (!priceEl || !info) return;
      var target = priceEl.querySelector('.hide-price-guest') || priceEl;
      var html =
        '<s class="vip-price__original">' + formatMoney(info.price) + '</s> ' +
        '<span class="vip-price__discounted">' + formatMoney(info.sale) + '</span>';
      if (target.innerHTML !== html) target.innerHTML = html;
    }

    function optionIndex(dropdown) {
      return parseInt(dropdown.getAttribute('option-target').replace('option', ''), 10) - 1;
    }

    // Each option value is priced as the variant it would select, keeping the other selected options
    function processOptionSwatches() {
      if (!variantData || !optionScope) return;
      var dropdowns = optionScope.querySelectorAll('[id^="swatch-option"][option-target^="option"]');
      if (!dropdowns.length) return;

      var variants = Object.keys(variantData).map(function (id) { return variantData[id]; });
      var current = variantData[getVariantIdFromSelect() || getVariantIdFromUrl()];
      var selected = current && current.options ? current.options.slice() : [];
      dropdowns.forEach(function (dropdown) {
        var item = dropdown.querySelector('.swatch-drop-down-list-item.swatch-selected[orig-value]');
        if (item) selected[optionIndex(dropdown)] = item.getAttribute('orig-value');
      });

      function saleInfo(index, value) {
        var wanted = selected.slice();
        wanted[index] = value;
        var match = variants.find(function (v) {
          return v.options && v.options.every(function (optionValue, i) { return optionValue === wanted[i]; });
        });
        if (!match || match.sale_price == null) return null;
        return { price: match.price, sale: Math.round(parseFloat(match.sale_price) * 100) };
      }

      dropdowns.forEach(function (dropdown) {
        var index = optionIndex(dropdown);
        dropdown.querySelectorAll('.swatch-drop-down-list-item[orig-value]').forEach(function (item) {
          applyPrice(item.querySelector('.dropdown-swatch-price'), saleInfo(index, item.getAttribute('orig-value')));
        });
        var header = dropdown.querySelector('.swatch-drop-down-inner > .swatch-drop-down');
        if (header && selected[index] != null) {
          applyPrice(header.querySelector(':scope > .d-flex .dropdown-swatch-price'), saleInfo(index, selected[index]));
        }
      });
    }

    function processSwatches() {
      processOptionSwatches();

      var items = document.querySelectorAll('.swatch-drop-down-list-item[swatch-url]');
      if (!items.length) return;

      loadSales().then(function (sales) {
        if (!Object.keys(sales).length) return;

        items.forEach(function (item) {
          applyPrice(item.querySelector('.dropdown-swatch-price'), sales[handleFromUrl(item.getAttribute('swatch-url'))]);
        });

        // The closed dropdown shows the selected product's price
        document.querySelectorAll('.swatch-drop-down-inner').forEach(function (inner) {
          var selected = inner.querySelector('.swatch-drop-down-list-item.swatch-selected[swatch-url]');
          var header = inner.querySelector(':scope > .swatch-drop-down');
          if (!selected || !header) return;
          applyPrice(header.querySelector(':scope > .d-flex .dropdown-swatch-price'), sales[handleFromUrl(selected.getAttribute('swatch-url'))]);
        });
      });
    }

    processSwatches();
    // Swatch King renders after load and re-renders on selection
    new MutationObserver(function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(processSwatches, 100);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ------------------------------------------
     7. Initialize on DOM Ready
     ------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initPopup();
    initVariantPriceUpdates();
    initBoostVipPrices();
    initCartVipDiscount();
    initPublicSaleCartSync();
    initSwatchSalePrices();
  }
})();
